import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "What a hockey legend can teach you about career development",
  "description": "Say your boss gives you $1000 to grow your career. What do you do?",
  "published": "2019-05-09T00:00:00.000Z",
  "redirect_from": ["/blog/what-a-hockey-legend-can-teach-you-about-career-development/swizec/9071"],
  "categories": "Opinions, SeniorMindset",
  "content_upgrade": "SeniorMindset",
  "hero": "./img/screenshot-1602866433788.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Say your boss gives you $1000 to grow your career. What do you do?`}</p>
    <p>{`That's what we talked about at an engineering growth lunch. A weekly get-together with the engineering team. It's like a mastermind. We talk about careers, web technologies, share things we learned, cool hacks we built, it's great. Best part of the week.`}</p>
    <p>{`So, $1000 for your career, what do you do?`}</p>
    <p>{`You go to a conference, you buy a book, you do a video course, you hire a coach, you attend a workshop, you get lost in the sea of options, you ...`}</p>
    <p>{`Ideas fly back and forth. Ideas fill the room. Ideas up to your ears. Everyone has plenty except our two most experienced engineers who are silent.`}</p>
    <p><em parentName="p">{`"What do you want?"`}</em></p>
    <p>{`The young guys look at us, ears cocked.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media3.giphy.com/media/eNMa1YRPDH3u2EITh6/giphy-loop.mp4?cid=7cf28b0f2cmbnv0d1btsyt4iztcaza9lxi7r07rpsh3vkw8i&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`We can't tell you what to do with your $1000, if you don't know what you want.`}</p>
    <ContentUpgrades.SeniorMindset />
    <p>{`Conferences are great for seeing what's out there and chatting with smart people. Workshops are amazing for intense rapid learning on something specific. Video courses and books are spectacular at going in depth on a topic.`}</p>
    <p>{`So what do you want? Where do you want your career to go?`}</p>
    <p>{`They had never thought about that before.`}</p>
    <p>{`🤔`}</p>
    <h2 {...{
      "id": "skate-where-the-puck-is-going"
    }}>{`Skate where the puck is going`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "750px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/5066d17d980bfe107309f7e899af39f8/acb04/view-img-11004125-wayne-gretzky750xx1136-639-0-1.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2032v32h37l62-2h25l3-3%204-3%201-1%203-4%205-3c3-3%2018%201%2019%205%200%202-1%206-4%209-2%203%201%205%2010%205l7-1-2-4c-4-8-1-24%204-20l5%202%2010%202c-3%200-7%203-7%205s6%203%208%200h4c3%200%203-2%200-4-2-1-2-1%200-1%204%200%205%204%205%2012-1%207-3%2011-7%2015-2%202-2%202%200%202l8-2c0-2%200-2%201-1%202%202%201%203-3%206-4%202-4%202-9%201l-7-3h-2c0%202%203%205%209%208l6%203%206-6%207-4-13%2013c-4%200-19-12-19-15s-3-3-20-3c-16%201-17%201-28%207-4%202-7%203-10%200-2-1-2-1-2%203%200%205-6%2012-9%2012s-3%204%200%205c10%203%2019%209%2020%2014l5%203c4%200%205%204%203%208-3%204-2%205%201%208l2%205%207%205c9%206%2010%207%203%204-9-4-13-7-13-9%200-4-1-5-4-5l-3-1-2-7c-2-5-3-8%200-8h1c0-1-5-4-11-6-12-6-13-8-16-19l-2-6v7c1%207%201%207-1%206s-4%200-3%203v3c0%202%200%202%201%201l1-1v2c-3%204-2%205%200%205%202%201%202%201%201%203-2%203-1%203%206%202%209%200%2017%201%2017%202l-4%201-9%201c-21%205-21%205-16%2013l4%207%205%207%203%204%201%201c2%200%202%200%200%202-4%205-1%2027%204%2030%203%202%2024%202%2029%201%207-2%209-11%203-11-5%200-6-1-5-4%200-3%203-5%206-5l3-1%202-1v1a1280%201280%200%200179-4c2%200%203%200%202-2%200-1%200-2%202-2l2-3c0-3%201-5%203-5%201%200%201%201-1%203v1l1%203v4l2-3%202-5c-1-4%201-5%2010-10%2011-6%2012-6%2014-5l2%201%201%201%201%201c2%200%203%204%202%206s-2%201-2-1-1-3-2-3h-9l1%201%202%201h5l2%201-2%201v1l3%201c2%200%203%200%203%202s-2%204-3%202l-3-3a4502%204502%200%2001-11-4h-2l2-2c4-3%202-2-5%201-6%203-9%208-6%2010l1-2c0-6%2011-8%2016-3%203%203%205%207%203%208-1%201%203%201%208%201l11-2%201-8c0-7%202-8%202%200%200%205%201%201%203-9%202-9%202-10-1-10l-8-2c-4-2-6-3-9-2-5%201-5%201%200-4l3-4%202-1%202-1h-3c-4%200-6-1-7-7%200-4%200-5%202-7%202-1%202-2%201-2-8-1-10-2-14-9-6-13-20-22-32-21-7%201-8%201-11%205s-4%203-1-1l4-9c2-5%202-5%201-1%200%204%200%204%201%203l10-2c11-1%2012-2%204-4l-3-1%202-1h-2c-1%200-2%200-3-2l-1-1-2-1c-2-1-3-2-3-6s0-5-3-7c-3-3-3-3-2-8%200-7%202-8%207-6s6%206%207%2016c0%2011%200%2010%207%2013%206%203%2015%209%2015%2011s0%201-4-2l-4-2h-2v1c1%201%201%201-1%202-2%200-2%200%203%203%207%205%2010%207%2014%2016l5%208h6c8%200%208-1-3-11a80%2080%200%2001-12-14v-1a6118%206118%200%2000149%202l1-35V0H0v32m182-21c0%202-2%203-2%200-1-2-5%206-5%2010l-2%202c-2%200-3%201-1%203v2c-1%201-1%201%205%202h5c1%201%201%201%202-1l2-2c2%201%202-1%201-2l-1-3c0-3-3-3-6-2-2%201-3%200-1-2h4l3-1-2-1c-2%200-3%200-2-1%200-3%204-2%204%200%201%201%201%201%201-1s0-2%205-2l6%201c2%200%202%200%200%202s-3%204-1%204%204-2%204-5c1-2-1-3-7-4h-8c-3-1-4%200-4%201m9%2089c-10%203-19%2012-21%2020-2%206%206%2016%2015%2019%207%203%2020%202%2026-1%2011-6%2019-22%2014-29-4-7-24-12-34-9m78%201c-5%204-2%2014%203%2011%204-2%207%201%203%204-3%203-1%204%202%203%204-1%204-4%201-12s-5-10-9-6m-68%203c4%203%204%206%201%208-3%203-7%202-10%200-1-2-1-2%201-6l2-4-3%201c-10%202-21%2014-20%2021%201%204%208%2011%2013%2013%205%203%2016%203%2022%201%2012-5%2022-21%2017-28-2-2-15-7-21-9h-4l2%203m3-1l1%203c2%203%200%207-3%208-2%202-2%202%204%202l8-2c1-1%205-1%204%201h-2c-2%200-1%202%201%203%201%200%202%201%202%203l1%204%201-3c2-3%201-9-1-11-2-3-16-9-16-8m-20%205c-6%205-9%209-9%2014%200%208%2011%2016%2021%2016%203%200%202-1-2-1-8-2-13-6-14-11-2-6-1-7%205-7l7-2c2%200%202%200%202%202v5c0%202%200%202%201%201%201-2%202-2%202-1%201%201%201%200%201-3-1-3%200-4%201-4l1-1-4-1c-4%200-7-4-6-7%201-4%200-4-6%200m-12%2047h-2c-4%200%200%202%207%204%205%202%207%202%2013%201h11l18-5a979%20979%200%2000-47%200m73%206v4l-4%201c-3%201-5-1-4-3%200-2-1-2-6-1l-3%201h2c3%200%203%201%201%202l-5%202-40%204c-44%202-43%202-41%205l1%206c-1%202%200%203%202%204l5%207c6%208%209%2013%209%2011h2v-1l-1-1-4-8c-5-8-5-9-2-9%202-1%203%200%205%204l14%2015c9%209%209%2010%208%2012-1%204-3%204-9-3-3-4-5-5-5-4l2%203c2%200%201%202-1%201l-2-1-1-1-1%202h1l1%201c-1%201%200%203%201%203l1%203c0%205%202%205%2031%205h28l-1-5c-2-6-5-10-10-12-4-1-7-6-8-12v-4l2%203%2015%2014c2%202%204%204%205%209l2%207h50l-2-4v-7c3-2%202-6-2-15-5-10-5-6-1%206%202%204%202%205%200%206-2%202-4%200-4-5a325%20325%200%2000-9-33v-4l2-2h-13c-2%201-3%201-4-1-1-1-1-1%201-1%201%201%202%201%203-1%202-2%204-3%206-2l2-1c2-1%202-1-2-1s-5%200-4-1l-3-1-2%202c0%202-1%201-4-1-4-3-4-3-4%202m152%202l-11%203-15%203%203%202%208%203c12%201%2015%205%2010%2014-3%207-3%2013%202%2019l5%205c1%201%201-7%201-24l-1-26-2%201m-242%2041c-3%209%202%2017%207%2012%203-2%202-5-4-11l-2-3-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5066d17d980bfe107309f7e899af39f8/ca0a1/view-img-11004125-wayne-gretzky750xx1136-639-0-1.webp 223w", "/static/5066d17d980bfe107309f7e899af39f8/75680/view-img-11004125-wayne-gretzky750xx1136-639-0-1.webp 445w", "/static/5066d17d980bfe107309f7e899af39f8/08b4d/view-img-11004125-wayne-gretzky750xx1136-639-0-1.webp 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5066d17d980bfe107309f7e899af39f8/853b2/view-img-11004125-wayne-gretzky750xx1136-639-0-1.jpg 223w", "/static/5066d17d980bfe107309f7e899af39f8/0a4fe/view-img-11004125-wayne-gretzky750xx1136-639-0-1.jpg 445w", "/static/5066d17d980bfe107309f7e899af39f8/acb04/view-img-11004125-wayne-gretzky750xx1136-639-0-1.jpg 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5066d17d980bfe107309f7e899af39f8/acb04/view-img-11004125-wayne-gretzky750xx1136-639-0-1.jpg",
                "alt": "Wayne Gretzky in his element",
                "title": "Wayne Gretzky in his element",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Wayne Gretzky in his element`}</figcaption>{`
  `}</figure></p>
    <p>{`Wayne Gretzky once said`}</p>
    <blockquote>
      <p parentName="blockquote">{`skate to where the puck is going to be, not to where it has been`}</p>
    </blockquote>
    <p>{`What made Gretzky a legend so big even people like me who never watch sports know about him, is his uncanny ability to `}<em parentName="p">{`"consistently anticipate where the puck was going to be and executing the right move at the right time"`}</em><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Wayne_Gretzky"
      }}>{`[`}{`1`}{`]`}</a>{`.`}</p>
    <p>{`Think about it.`}</p>
    <p>{`The puck is moving. Flying. By the time you get there, you're too late.`}</p>
    <p>{`You gotta skate to where the puck is going to be. You can catch it when it gets there. 🏑`}</p>
    <p>{`Same goes for your career. And your skills.`}</p>
    <p>{`To have a successful career, you gotta move where the industry is going. Not where it's been in the past. What you see right now, that's already the past.`}</p>
    <p>{`The web moves fast.`}</p>
    <h2 {...{
      "id": "from-a-sea-of-options-how-do-you-choose"
    }}>{`From a sea of options, how do you choose`}</h2>
    <p>{`Ever heard of the adjacent possible?`}</p>
    <p>{`It's the idea that technology, biology, life in general, and your career develops around its edges. When you gain a new skill, invent a new tool, or pay off your loans, you expand your adjacent possible.`}</p>
    <p>{`You push out the edge and reach further into the world. More ideas become possible, more opportunities show up. All because you're in a better position to both see and use them.`}</p>
    <p>{`I like to think of it as a stochastic search problem. Multivariate optimization if you will.`}</p>
    <p>{`There's a lot that goes into a good career. And it's different for everyone.`}</p>
    <p>{`How much money are you making? Are you enjoying it? Are you working with tech you like? Are you helping the world? Are you happy?`}</p>
    <p>{`The solution is always the same. It looks like this 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`We just talked about this with the team yesterday. This is still the best advice I got`}<br parentName="p"></br><br parentName="p"></br>{`- look around`}<br parentName="p"></br>{`- identify tallest hill`}<br parentName="p"></br>{`- go for it`}<br parentName="p"></br>{`- reach peak`}<br parentName="p"></br>{`- taller better vantage`}<br parentName="p"></br>{`- look around`}<br parentName="p"></br>{`- identify tallest hill`}<br parentName="p"></br>{`- …`}<br parentName="p"></br><br parentName="p"></br>{`Multivariate optimization problem :)`}<a parentName="p" {...{
          "href": "https://t.co/bdbAoxVUia"
        }}>{`https://t.co/bdbAoxVUia`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1124843384546312192"
      }}>{`May 5, 2019`}</a></blockquote>
    <p>{`You look around and identify the tallest hill you can see.`}</p>
    <p>{`What's the hottest most sought-after technology right now? What looks like it's coming up fast? What problem are you most excited to solve? What gets your fire going?`}</p>
    <p>{`Go for it.`}</p>
    <p>{`Climb until you reach the top. Until your progress starts to slow. When you aren't learning and growing, that's when you've reached the top.`}</p>
    <p>{`You now have a better vantage point. You see further and wider. You have more experience. Your adjacent possible is broader.`}</p>
    <p>{`Look around, identify tallest hill, go for it.`}</p>
    <p>{`✌️`}</p>
    <p>{`Skate where the puck is going my friend`}</p>
    <p>{`Where do you want to skate your career? at me 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`If someone gave you $1000 to grow your career, would you know what to do?`}<br parentName="p"></br><br parentName="p"></br>{`Skate where the puck is going my friend`}<a parentName="p" {...{
          "href": "https://t.co/ew7Frl3Xni"
        }}>{`https://t.co/ew7Frl3Xni`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1126494559431618564"
      }}>{`May 9, 2019`}</a></blockquote>
    <p>{`Happy skating,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      